import React from 'react';
import { Typography } from 'mobily-ui-library/lib';
import HomeCheck from '../../Coverage/HomeCheck/HomeCheck';
import OntheGo from '../../Coverage/OntheGo/OntheGo';
import PublicWifi from '../../Coverage/PublicWifi/PublicWifi';

interface Props {
    handleHeadingClick: (value: number) => void;
    currentValue: number;
    rtl: boolean;
    coverageCheckData: [];
}

function CheckContainer({ handleHeadingClick, currentValue, rtl, coverageCheckData }: Props) {
    return (
        <div className='EC__SearchResult'>
            <span className='EC__Search--Heading' style={{borderBottom: coverageCheckData.length > 0  ? '1px solid #d5d8df' : 'none'}}>
                {coverageCheckData.length > 0 && coverageCheckData.map((el: any) => {
                    return (
                        <React.Fragment key={el.sectionLabelEn}>
                            <Typography className={el.sectionId === currentValue ? 'active' : ''} onClick={() => handleHeadingClick(el.sectionId)}>
                                {rtl ? el.sectionLabelAr : el.sectionLabelEn}
                            </Typography>
                        </React.Fragment>
                    )
                })}
            </span>
            {coverageCheckData.length > 0 && coverageCheckData.map((el: any) => {
                if (currentValue === el.sectionId) {
                    return (
                        <React.Fragment key={el.sectionLabelEn}>
                            <div className='EC__Search--options'>
                                {currentValue === 1 ? (
                                    <HomeCheck rtl={rtl} results={el.coverageResults} />
                                ) : (
                                    currentValue === 2 ? (
                                        <OntheGo rtl={rtl} results={el.coverageResults} />
                                    ) : (
                                        <PublicWifi rtl={rtl} />
                                    )
                                )}

                            </div>
                        </React.Fragment>
                    )
                }
            })}
        </div>
    )
}

export default CheckContainer;